export const ADD_CHAT_ITEM = "interview/ADD_CHAT_ITEM"
export const ADD_CHAT_ITEMS = "interview/ADD_CHAT_ITEMS"
export const SET_CHAT_ITEMS = "interview/SET_CHAT_ITEMS"
export const UPDATE_ACTIVE_INDEX = "interview/UPDATE_ACTIVE_INDEX"
export const DELETE_CHAT_ITEMS = "interview/DELETE_CHAT_ITEMS"
export const SET_LOADING = "interview/SET_LOADING"
export const SET_ACTIVE_IMAGE = "interview/SET_ACTIVE_IMAGE"
export const SET_SUBMISSION_QUEUE = "interview/SET_SUBMISSION_QUEUE"
export const ADD_TO_SUBMISSION_QUEUE = "interview/ADD_TO_SUBMISSION_QUEUE"
export const SET_EDIT_CONFIRM_NEEDED = "interview/SET_EDIT_CONFIRM_NEEDED"
export const SET_EDIT_CONFIRM_SHOWN = "interview/SET_EDIT_CONFIRM_SHOWN"
export const SET_DELETE_CONFIRM_NEEDED = "interview/SET_DELETE_CONFIRM_NEEDED"
export const SET_DELETE_CONFIRM_SHOWN = "interview/SET_DELETE_CONFIRM_SHOWN"
export const SET_MESSAGE = "interview/SET_MESSAGE"
export const SET_STASHED_RESPONSE = "interview/SET_STASHED_RESPONSE"
export const SET_INTERVIEW_STARTED = "interview/SET_INTERVIEW_STARTED"
export const SET_CACHED_QUESTION = "interview/SET_CACHED_QUESTION"
export const SET_RESPONSE = "interview/SET_RESPONSE"
export const ADD_RESPONSE = "interview/ADD_RESPONSE"
export const REMOVE_RESPONSE = "interview/REMOVE_RESPONSE"
export const SET_DURATION_AMOUNT = "interview/SET_DURATION_AMOUNT"
export const SET_DURATION_UNIT = "interview/SET_DURATION_UNIT"
export const SET_FREE_TEXT = "interview/SET_FREE_TEXT"
export const SET_DIAGNOSES = "interview/SET_DIAGNOSES"
export const SET_PRED_INFO = "interview/SET_PRED_INFO"
export const SET_RESOURCE = "interview/SET_RESOURCE"
export const SET_TRAIN_MSG_SHOWN = "interview/SET_TRAIN_MSG_SHOWN"
export const SET_FILTER_ERROR = "interview/SET_FILTER_ERROR"
export const SET_RESPONSE_HEIGHT = "interview/SET_RESPONSE_HEIGHT"
export const SET_TERMS_MODAL_SHOWN = "interview/SET_TERMS_MODAL_SHOWN"
export const SET_SHOW_GINA_MODAL = "interview/SET_SHOW_GINA_MODAL"
export const SET_ITEM_BLUR = "interview/SET_ITEM_BLUR"
export const SET_ERROR = "identifiers/SET_ERROR"
export const SET_ERROR_CODE = "identifiers/SET_ERROR_CODE"
export const SET_CONFIRM_MESSAGE_SHOWN = "interview/SET_CONFIRM_MESSAGE_SHOWN"
export const SET_CONFIRM_MESSAGE = "interview/SET_CONFIRM_MESSAGE"
export const SET_VISIT_TOKEN = "interview/SET_VISIT_TOKEN"



// WEBPACK FOOTER //
// ./assets/interview/actionTypes.js